// src/pages/portfolio/data/projectsData.js

// Portfolio Website
import protfolioImage from '../../../images/portofolioimages/lipostyleePortfolioWebsite.png';
import protfolioImageLogo from '../../../images/logo/logo.svg';

// E-nutritionist Website
import enutritionistImage from '../../../images/portofolioimages/EnutritionistWebsite.png';
import enutritionistimageLogo from '../../../images/portofolioimages/enutritionistLogo.svg';

// Smart Ride Website
import smartRideImage from '../../../images/portofolioimages/smartrideWebsite.png';
import smartRideImageLogo from '../../../images/portofolioimages/smartrideLogo.png';

const projects = [
  {
    id: 'project1',
    title: 'Lipostyle Portfolio Website',
    description:
      "A modern portfolio website built with React.js using a fully modular component-based architecture. Each UI section is developed with its own JSX and CSS file for better scalability and maintainability. The site emphasizes responsive design, smooth animations, and a clean user experience. Source code is hosted on GitHub, and the live site is deployed via HostGator.",
    purpose: {
      paragrapgh:
        "The portfolio serves as a central hub for potential clients, collaborators, and employers to:",
      itemlist: [
        "Learn about my background, skills, and web development journey.",
        "Explore detailed previews of my featured projects.",
        "Easily get in touch for opportunities or inquiries through the contact page."
      ]
    },
    pagesNfeatures: [
      {
        page: "Home Page",
        pageDescription: [
          {
            sectionName: "Hero Section",
            sectionDescritpion:
              "Introduces who I am with clear CTA buttons to view work, contact, or download CV."
          },
          {
            sectionName: "About Preview",
            sectionDescritpion:
              "Quick overview of my background and career shift into web development."
          },
          {
            sectionName: "Skills Preview",
            sectionDescritpion:
              "Highlights key technologies and tools in a responsive carousel layout."
          },
          {
            sectionName: "Portfolio Preview",
            sectionDescritpion:
              "Showcases selected projects in card format with links to detailed pages and live demos."
          }
        ]
      },
      {
        page: "Portfolio Page",
        pageDescription: [
          {
            sectionName: "Side Navigation",
            sectionDescritpion:
              "Enables seamless navigation between different projects."
          },
          {
            sectionName: "Project Details",
            sectionDescritpion:
              "Dedicated layout for in-depth project descriptions, features, and links."
          }
        ]
      },
      {
        page: "About Page",
        pageDescription:
          "Provides a personal narrative about my career journey and development philosophy."
      },
      {
        page: "Contact Page",
        pageDescription: [
          {
            sectionName: "Contact Information",
            sectionDescritpion:
              "Provides professional channels like email, phone, and social links."
          },
          {
            sectionName: "Contact Form",
            sectionDescritpion:
              "Interactive form for visitors to send inquiries, collaboration requests, or feedback."
          }
        ]
      }
    ],

    // Paragraph for Tech Stack Section
    techStackIntro:
      "Below are the core technologies used to build this project, carefully chosen for scalability, maintainability, and a smooth user experience.",

    // Improved Tech Stack (array of objects)
    techStack: [
      {
        icon: '⚛️',
        name: 'React.js',
        note: 'Component-Based Architecture'
      },
      {
        icon: '🎨',
        name: 'Custom CSS Modules',
        note: 'Scoped Styling'
      },
      {
        icon: '📜',
        name: 'JavaScript',
        note: 'ES6+'
      },
      {
        icon: '📱',
        name: 'Responsive & Animated UI Design',
        note: 'Optimized for all screen sizes'
      },
      {
        icon: '🐙',
        name: 'GitHub',
        note: 'Version Control & Deployment'
      },
      {
        icon: '🌐',
        name: 'HostGator',
        note: 'Live Hosting'
      }
    ],

    // Paragraph for Key Highlights Section
    featuresIntro:
      "Here are some standout aspects of this project that showcase its design principles, technical approach, and user‑focused experience.",

    // Key Highlights
    features: [
      {
        icon: '✨',
        title: 'Modern UI/UX',
        description:
          'Minimalist, professional design with smooth animations and fully responsive layouts.'
      },
      {
        icon: '🧩',
        title: 'Component‑Based Architecture',
        description:
          'Each section is modular for better maintainability, scalability, and reusability.'
      },
      {
        icon: '🎨',
        title: 'Glassmorphic & Thematic Elements',
        description:
          'Subtle visual enhancements for a polished, modern aesthetic with background overlays.'
      },
      {
        icon: '📱',
        title: 'Mobile‑First Approach',
        description:
          'Optimized for different screen sizes and devices for seamless accessibility.'
      }
    ],

    image: protfolioImage,
    logo: protfolioImageLogo,
    github: 'https://github.com/LipoStyle/lipostyleePortfolio',
    live: 'https://lipostylee.com'
  },

  // Keep other projects unchanged for now
 {
  id: 'project2',
  title: 'E-Nutritionist',
  description:
    "A full-stack website built for a professional nutritionist to showcase services, share recipes and blogs, and allow clients to book consultations. The project includes a public-facing site and an admin dashboard for content management.",
  purpose: {
    paragrapgh:
      "The platform was developed to establish a strong online presence for the nutritionist and provide value to clients by:",
    itemlist: [
      "Showcasing services, blogs, and recipes to attract and inform clients.",
      "Providing an easy booking system for consultations.",
      "Empowering the admin to manage all content (blogs, recipes, services) from one dashboard."
    ]
  },
  pagesNfeatures: [
    {
      page: "Home Page",
      pageDescription: [
        {
          sectionName: "Hero Section",
          sectionDescritpion:
            "Introduces the nutritionist with a welcoming message, featured services, and call-to-action buttons."
        },
        {
          sectionName: "Concepts Carousel",
          sectionDescritpion:
            "Highlights core nutrition philosophies with modern carousel animations."
        },
        {
          sectionName: "Service Plans Preview",
          sectionDescritpion:
            "Displays featured services with quick links to detailed service pages."
        },
        {
          sectionName: "Blog & Recipes Preview",
          sectionDescritpion:
            "Showcases latest posts and recipes to engage and inform visitors."
        }
      ]
    },
    {
      page: "Services Page",
      pageDescription:
        "Detailed view of all nutrition plans and services, with pricing and feature breakdowns."
    },
    {
      page: "Blogs & Recipes Pages",
      pageDescription: [
        {
          sectionName: "Blog Listing",
          sectionDescritpion:
            "Dynamic, multilingual blog feed with SEO-friendly slugs."
        },
        {
          sectionName: "Recipe Catalog",
          sectionDescritpion:
            "Categorized recipes with detailed instructions, ingredients, and nutritional facts."
        }
      ]
    },
    {
      page: "About Page",
      pageDescription:
        "Introduces the nutritionist’s background, philosophy, and expertise with a professional portrait."
    },
    {
      page: "Contact Page",
      pageDescription: [
        {
          sectionName: "Contact Information",
          sectionDescritpion:
            "Provides direct contact details, location, and social media links."
        },
        {
          sectionName: "Contact Form",
          sectionDescritpion:
            "Allows visitors to send inquiries or feedback via an interactive form."
        }
      ]
    },
    {
      page: "Booking Page",
      pageDescription:
        "Integrated booking system where clients can choose a service, date, and time for consultations."
    },
    {
      page: "Admin Dashboard",
      pageDescription: [
        {
          sectionName: "Login & Authentication",
          sectionDescritpion:
            "Secure login flow for the nutritionist to access the admin panel."
        },
        {
          sectionName: "Content Management",
          sectionDescritpion:
            "Full CRUD capabilities for blogs, recipes, and services."
        },
        {
          sectionName: "Subscribers & Bookings",
          sectionDescritpion:
            "Admin can view and delete subscribers and bookings."
        }
      ]
    }
  ],

  // Tech Stack Section
  techStackIntro:
    "E-Nutritionist combines a robust Ruby on Rails backend with a modern React.js frontend, ensuring seamless content management and engaging user experiences.",
  techStack: [
    { icon: '⚛️', name: 'React.js', note: 'Dynamic frontend for public and admin views' },
    { icon: '🟧', name: 'Ruby on Rails', note: 'Backend API and admin dashboard logic' },
    { icon: '🎨', name: 'Custom CSS & Animations', note: 'Responsive styling and smooth UI transitions' },
    { icon: '🔗', name: 'REST API', note: 'Seamless communication between frontend and backend' },
    { icon: '🗄️', name: 'PostgreSQL', note: 'Relational database for blogs, recipes, and bookings' },
    { icon: '☁️', name: 'Heroku & HostGator', note: 'Deployment for backend and frontend' }
  ],

  // Features Section
  featuresIntro:
    "Key highlights of E-Nutritionist showcase its ability to merge rich content with seamless admin control:",
  features: [
    { icon: '✨', title: 'Animations & Carousels', description: 'Interactive UI with smooth animations and carousel components for concepts and services.' },
    { icon: '📱', title: 'Fully Responsive Design', description: 'Optimized for desktops, tablets, and mobile devices.' },
    { icon: '🧾', title: 'Dynamic Content', description: 'Public-facing blogs, recipes, and services powered by the backend.' },
    { icon: '🔒', title: 'Admin Dashboard', description: 'Secure login with full content management (CRUD) for recipes, blogs, services, and bookings.' },
    { icon: '📅', title: 'Booking System', description: 'Clients can book consultations, and admin can view/manage bookings.' },
    { icon: '🌐', title: 'Multilingual Support', description: 'Content available in multiple languages for broader audience reach.' }
  ],

  image: enutritionistImage,
  logo: enutritionistimageLogo,
  github: 'https://github.com/lipostyle/e-nutritionist',
  live: 'https://e-nutritionist.com'
},
  {
  id: 'project3',
  title: 'Smart Ride',
  description:
    "A multilingual scooter rental website for a local company in Skiathos Island, Greece. Built to showcase available scooters and provide an easy booking process for tourists during their holiday.",
  purpose: {
    paragrapgh:
      "Smart Ride was created to serve both the business and its customers by:",
    itemlist: [
      "Showcasing the scooter fleet with details and pricing.",
      "Providing tourists a quick way to reserve scooters online during their stay.",
      "Offering multilingual support to cater to international visitors.",
      "Ensuring a mobile-friendly experience for users on the go."
    ]
  },
  pagesNfeatures: [
    {
      page: "Home Page",
      pageDescription: [
        {
          sectionName: "Hero Section",
          sectionDescritpion:
            "Introduces the company with a welcoming message and call-to-action buttons leading to booking and scooters pages."
        },
        {
          sectionName: "Scooter Highlights",
          sectionDescritpion:
            "Displays featured scooters in a clean grid with quick links to detailed information."
        },
        {
          sectionName: "Booking Preview",
          sectionDescritpion:
            "Teaser section encouraging visitors to proceed to the booking form."
        }
      ]
    },
    {
      page: "Our Scooters Page",
      pageDescription:
        "Detailed listing of available scooters with descriptions, specifications, and images."
    },
    {
      page: "About Us Page",
      pageDescription:
        "Provides company background, mission, and local connection to Skiathos Island."
    },
    {
      page: "Terms and Conditions Page",
      pageDescription:
        "Outlines rental policies, usage guidelines, and legal disclaimers for transparency."
    },
    {
      page: "Contact Us Page",
      pageDescription: [
        {
          sectionName: "Contact Information",
          sectionDescritpion:
            "Shows business location, phone number, and email with social links."
        },
        {
          sectionName: "Contact Form",
          sectionDescritpion:
            "Interactive PHP-powered form for customer inquiries."
        }
      ]
    },
    {
      page: "Book Now Page",
      pageDescription:
        "Dedicated PHP form for booking scooters, collecting details like date, scooter type, and personal info."
    }
  ],

  // Tech Stack Section
  techStackIntro:
    "Smart Ride leverages React.js for a responsive frontend and PHP for lightweight booking and contact form handling, making it ideal for quick deployments on shared hosting.",
  techStack: [
    { icon: '⚛️', name: 'React.js', note: 'Frontend framework for dynamic UI' },
    { icon: '🎨', name: 'Custom CSS', note: 'Responsive, mobile-first design' },
    { icon: '📝', name: 'PHP', note: 'Handles contact and booking forms' },
    { icon: '🌐', name: 'Multilingual Support', note: '4 languages for international tourists' },
    { icon: '📱', name: 'Responsive UI', note: 'Optimized for mobile and tablet users' },
    { icon: '☁️', name: 'HostGator', note: 'Live hosting and deployment' }
  ],

  // Features Section
  featuresIntro:
    "Smart Ride focuses on providing a simple yet effective rental experience, with clear visuals and straightforward booking:",
  features: [
    { icon: '✨', title: 'Modern UI/UX', description: 'Minimalist layout focused on showcasing scooters and ease of booking.' },
    { icon: '📱', title: 'Fully Responsive', description: 'Designed for travelers using mobile devices on the go.' },
    { icon: '🌐', title: 'Multilingual Support', description: '4 languages supported for international tourists.' },
    { icon: '🛵', title: 'Scooter Showcase', description: 'Dedicated pages with details and images of available scooters.' },
    { icon: '📩', title: 'PHP Booking Form', description: 'Simple backend logic for bookings and inquiries via email.' },
    { icon: '⚡', title: 'Fast Deployment', description: 'Optimized for quick loading on shared hosting.' }
  ],

  image: smartRideImage,
  logo: smartRideImageLogo,
  github: 'https://github.com/lipostyle', // Placeholder if no repo
  live: 'https://smartride.gr'
}

];

export default projects;
